export const MAINTENANCE_HEALTH_ENDPOINT = '/health'
export const MAINTENANCE_DEFAULT_POLL_INTERVAL_MS = 30000
export const MAINTENANCE_MIN_POLL_INTERVAL_MS = 30000
export const MAINTENANCE_MAX_POLL_INTERVAL_MS = 60000
export const MAINTENANCE_HEALTH_CHECK_CONFIG = {
	timeout: 10000,
	__skipCredentials: true,
	__skipAuthHeader: true,
	__skipGlobalErrorToast: true,
	__skipMaintenanceHandling: true,
	__skip404Toast: true
}

function clampPollInterval(intervalMs) {
	if (!Number.isFinite(intervalMs) || intervalMs <= 0) {
		return MAINTENANCE_DEFAULT_POLL_INTERVAL_MS
	}

	return Math.min(
		MAINTENANCE_MAX_POLL_INTERVAL_MS,
		Math.max(MAINTENANCE_MIN_POLL_INTERVAL_MS, intervalMs)
	)
}

function readHeader(headers, name) {
	if (!headers) {
		return null
	}

	if (typeof headers.get === 'function') {
		return headers.get(name) || headers.get(name.toLowerCase())
	}

	return headers[name] || headers[name.toLowerCase()] || null
}

export function parseRetryAfterMs(retryAfter, now = Date.now()) {
	if (!retryAfter) {
		return MAINTENANCE_DEFAULT_POLL_INTERVAL_MS
	}

	const retryAfterSeconds = Number(retryAfter)

	if (Number.isFinite(retryAfterSeconds)) {
		return clampPollInterval(retryAfterSeconds * 1000)
	}

	const retryAfterDate = Date.parse(retryAfter)

	if (!Number.isNaN(retryAfterDate)) {
		return clampPollInterval(retryAfterDate - now)
	}

	return MAINTENANCE_DEFAULT_POLL_INTERVAL_MS
}

export function getRetryAfterMsFromResponse(response) {
	return parseRetryAfterMs(
		readHeader(response && response.headers, 'Retry-After')
	)
}

export function isMaintenanceResponse(error) {
	return Number(error && error.response && error.response.status) === 503
}

function getVanityHealthEndpoint(apiVanityUrl) {
	if (typeof apiVanityUrl !== 'string' || apiVanityUrl.trim() === '') {
		return null
	}

	return `${apiVanityUrl.replace(/\/+$/, '')}/api/health`
}

async function isBackendReachableThroughVanityUrl($axios, apiVanityUrl) {
	const endpoint = getVanityHealthEndpoint(apiVanityUrl)

	if (!endpoint) {
		return false
	}

	try {
		const response = await $axios.get(
			endpoint,
			MAINTENANCE_HEALTH_CHECK_CONFIG
		)

		return response.status >= 200 && response.status < 300
	} catch (error) {
		return isMaintenanceResponse(error)
	}
}

export async function getMaintenanceHealthStatus($axios, apiVanityUrl = '') {
	try {
		const response = await $axios.get(
			MAINTENANCE_HEALTH_ENDPOINT,
			MAINTENANCE_HEALTH_CHECK_CONFIG
		)

		return response.status >= 200 && response.status < 300
			? { status: 'healthy', response }
			: { status: 'unknown', response }
	} catch (error) {
		if (isMaintenanceResponse(error)) {
			return {
				status: 'maintenance',
				response: error.response
			}
		}

		if (
			!error.response &&
			(await isBackendReachableThroughVanityUrl($axios, apiVanityUrl))
		) {
			return {
				status: 'maintenance',
				response: null
			}
		}

		return {
			status: 'unknown',
			error
		}
	}
}

export function getRouteFullPath(route) {
	return route && route.fullPath ? route.fullPath : '/'
}
